module.exports = __webpack_public_path__ + "../resources/img/ic_web_guide.00c4df54.svg";